import axios from 'axios';
import { AppError } from './AppError';

const baseURL = import.meta.env.VITE_ERLIA_AUTH_URL;

/**
 * Cliente HTTP hacia erlia-auth (User Directory).
 * El Bearer JWT se adjunta en configureAuthInterceptor.
 */
export const authApi = axios.create({
  baseURL: baseURL ? baseURL.replace(/\/$/, '') : '',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

authApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const serverData = error.response?.data;
    let message = error.message;

    if (serverData && typeof serverData === 'object') {
      message =
        serverData.message ||
        serverData.error ||
        error.message ||
        'Error del servidor';
    } else if (!error.response) {
      message = 'Error de conexión con el directorio de usuarios. Verifica tu internet e intenta nuevamente.';
    }

    const appError = new AppError(message, status, serverData);
    return Promise.reject(appError);
  }
);

authApi.interceptors.request.use(
  (config) => {
    if (!baseURL) {
      return Promise.reject(
        new AppError('VITE_ERLIA_AUTH_URL no está configurado', undefined, undefined)
      );
    }
    return config;
  },
  (error) => Promise.reject(error)
);
